import styled, { css } from 'styled-components';
interface Props {
  iswidth?: boolean;
  ieTextdot?: boolean;
  isCreateTask?: boolean;
  isCustomcontextmenu?: boolean;
  isRemovepadding?: boolean;
  isStatusIcon?: boolean;
  isResponsiveStatusIcon?: boolean;
  isHoverIcon?: boolean;
}

const ButtonIcon = styled.div<Props>`
  ${(props: Props) =>
    props.isHoverIcon &&
    css`
      padding: 4px;
      border-radius: 12px;
      :hover {
        background-color: var(--neutral-secondary);
        svg {
          filter: brightness(var(--brightness-value));
          .transparent-fill {
            fill: none;
          }
        }
      }
    `}
`;
export { ButtonIcon };
